import React from 'react';
import { X, Check } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['Spending hours planning after work', 'Constantly looking for drill inspiration', 'Repeating the same old exercises', 'Feeling uncertain about tactical progressions', 'Mental overload every single week'];
  const after = ['Professional sessions ready in minutes', 'Clear structure and seasonal progression', 'Endless tactical drills organized for you', 'Greater coaching confidence and authority', 'More free time and zero evening stress'];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-19">
          {/* Before */}
          <div className="bg-gray-50 border border-gray-100 rounded-3xl p-8 sm:p-10" data-id="element-20">
            <h3 className="font-display text-lg font-semibold text-gray-500 mb-8 text-center uppercase tracking-[0.15em]" data-id="element-21">
              BEFORE HOCKEY READY
            </h3>
            <ul className="space-y-6" data-id="element-22">
              {before.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-500" data-id="element-23">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-24" />
                  <span className="leading-relaxed" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-pilates-sage/10 border border-pilates-sage/30 rounded-3xl p-8 sm:p-10 shadow-lg relative overflow-hidden" data-id="element-26">
            <div className="absolute top-0 right-0 w-40 h-40 bg-pilates-sage/20 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none" data-id="element-27"></div>
            <h3 className="font-display text-lg font-semibold text-pilates-sage-dark mb-8 text-center uppercase tracking-[0.15em] relative z-10" data-id="element-28">
              AFTER HOCKEY READY
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-29">
              {after.map((item, i) => <li key={i} className="flex items-start gap-3 text-pilates-dark font-medium" data-id="element-30">
                  <Check className="w-5 h-5 text-pilates-sage-dark flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-31" />
                  <span className="leading-relaxed" data-id="element-32">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}